"use client";

import staticData from "@/public/data/flight/results.json";
import Flex from "@/shared/components/common/Flex";
import type { Flight } from "@/types/services/flight/apis/Availability";
import RoundtripCardItem from "./RoundtripCardItem";
import useSessionStorage from "@/shared/hooks/useSessionStorage";
import { useSearchParams } from "next/navigation";
import { useRouter } from "next/navigation";
import Typography from "@/shared/components/common/Typography";
import PhosphorIcon from "@/shared/components/common/PhosphorIcon";
import { cn } from "@/shared/libs/commonUtils";
import RoundtripCardItemEmpty from "./RoundtripCardItemEmpty";
import { useDeviceType } from "@/shared/context/DeviceContext";

export type Route = {
  origin: string;
  destination: string;
};

interface RoundtripCardProps {
  flights: Flight[];
  searchParams: SearchParams;
  route: Route;
}

export default function RoundtripCard({
  flights,
  searchParams,
  route,
}: RoundtripCardProps) {
  const { yourFlightLabel } = staticData.roundTrip;
  const router = useRouter();
  const params = useSearchParams();

  const [departure, setDeparture] = useSessionStorage<Flight | null>(
    "departure",
  );

  if (!params.get("departFlight") && departure) setDeparture(null);

  const handleChangeDeparture = () => {
    setDeparture(null);
    router.back();
  };

  if (!departure) return;

  return (
    <Flex
      direction={"col"}
      className="bg-background ring-1 ring-border rounded-sm"
    >
      <Flex.Item
        className={cn(
          "w-full p-3 hidden md:flex",
          departure ? "border-b-[1px] border-grayColor" : "",
        )}
      >
        <Flex alignItems={"center"} gap={"2"}>
          <Flex.Item>
            <PhosphorIcon
              name="AirplaneTilt"
              size={22}
              className="text-grayColor-foreground !transform !scale-x-[-1]"
            />
          </Flex.Item>
          <Flex.Item>
            <Typography variant={"body3"}>{yourFlightLabel}</Typography>
          </Flex.Item>
        </Flex>
      </Flex.Item>

      {departure ? (
        <RoundtripCardItem
          flight={departure}
          route={route}
          changeDeparture={handleChangeDeparture}
        />
      ) : (
        <RoundtripCardItemEmpty direction={"departure"} />
      )}

      {useDeviceType() === "desktop" && (
        <RoundtripCardItemEmpty direction={"return"} />
      )}
    </Flex>
  );
}
